export const ages = [
	{ value: "17 of jonger", label: "17 of jonger" },
	{ value: "18-20", label: "18-20" },
	{ value: "21-29", label: "21-29" },
	{ value: "30-39", label: "30-39" },
	{ value: "40-49", label: "40-49" },
	{ value: "50-59", label: "50-59" },
	{ value: "60-69", label: "60-69" },
	{ value: "70 of ouder", label: "70 of ouder" },
];

export const arrangements = [
	{ value: "Ik heb een koophuis", label: "Ik heb een koophuis" },
	{
		value: "ik huur van een particulier",
		label: "ik huur van een particulier",
	},
	{
		value: "ik huur van de woningbouwcoöperatie Veluwewonen",
		label: "ik huur van de woningbouwcoöperatie Veluwewonen",
	},
	{
		value: "ik huur van de woningbouwcoöperatie Ons Huis",
		label: "ik huur van de woningbouwcoöperatie Ons Huis",
	},
];

export const streets = [
	{ value: "Astaweg", label: "Astaweg" },
	{ value: "Bentweideweg", label: "Bentweideweg" },
	{ value: "Berenbergh", label: "Berenbergh" },
	{ value: "De Flesse", label: "De Flesse" },
	{ value: "De Haere", label: "De Haere" },
	{ value: "De Nieuwekamp", label: "De Nieuwekamp" },
	{ value: "De Poel", label: "De Poel" },
	{ value: "De Vennen", label: "De Vennen" },
	{ value: "De Wildkampen", label: "De Wildkampen" },
	{ value: "Elburgerweg", label: "Elburgerweg" },
	{ value: "Fluitersweg", label: "Fluitersweg" },
	{ value: "Greutelseweg", label: "Greutelseweg" },
	{ value: "Groeneveltweg", label: "Groeneveltweg" },
	{ value: "Hoekweg", label: "Hoekweg" },
	{ value: "Hoge Brink", label: "Hoge Brink" },
	{ value: "Houtentorenweg", label: "Houtentorenweg" },
	{ value: "Huisakkers", label: "Huisakkers" },
	{ value: "Jonas", label: "Jonas" },
	{ value: "Jonaserf", label: "Jonaserf" },
	{ value: "Kanaweg", label: "Kanaweg" },
	{ value: "Klein Cannenburgh", label: "Klein Cannenburgh" },
	{ value: "Kleine Fluitersweg", label: "Kleine Fluitersweg" },
	{ value: "Koninklijk Park", label: "Koninklijk Park" },
	{ value: "Kopermolenweg", label: "Kopermolenweg" },
	{ value: "Laagakkerweg", label: "Laagakkerweg" },
	{ value: "Marleweg", label: "Marleweg" },
	{ value: "Nieuwe Molenweg", label: "Nieuwe Molenweg" },
	{ value: "Oude Zwolseweg", label: "Oude Zwolseweg" },
	{ value: "Papegaaiweg", label: "Papegaaiweg" },
	{ value: "Plantageweg", label: "Plantageweg" },
	{ value: "Plasweideweg", label: "Plasweideweg" },
	{ value: "Ramsbrugweg", label: "Ramsbrugweg" },
	{ value: "Ridderweg", label: "Ridderweg" },
	{ value: "Schupperijweg", label: "Schupperijweg" },
	{ value: "Veldmaterweg", label: "Veldmaterweg" },
	{ value: "Wenumsedwarsweg", label: "Wenumsedwarsweg" },
	{ value: "Wenumseveldweg", label: "Wenumseveldweg" },
	{ value: "Wenumseweg", label: "Wenumseweg" },
	{ value: "Wielese kampweg", label: "Wielese kampweg" },
	{ value: "Wieselse Enkweg", label: "Wieselse Enkweg" },
	{ value: "Wieselsedwarsweg", label: "Wieselsedwarsweg" },
	{ value: "Wieselseweg", label: "Wieselseweg" },
	{ value: "Windhoek", label: "Windhoek" },
	{ value: "Zwolseweg", label: "Zwolseweg" },
];
